import { render } from "./CategoryCreateComponent.vue?vue&type=template&id=1e29098d"
import script from "./CategoryCreateComponent.vue?vue&type=script&lang=js"
export * from "./CategoryCreateComponent.vue?vue&type=script&lang=js"

import "./CategoryCreateComponent.vue?vue&type=style&index=0&id=1e29098d&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__